export const URL_START = '/start-interview/comparison';
export const DEFAULT_LOCALE = 'en';



// WEBPACK FOOTER //
// ./src/comparison/constants.js